import React from "react";
import {
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditIcon from "@mui/icons-material/Edit";

const RRHH = localStorage.getItem("adminrrhh") === "1";

const PeriodActionMenu = ({ row, onApprove, onReject, onEdit, onPdf }) => {
  // Mapear los tres posibles períodos de la fila
  const periods = [1, 2, 3].map((i) => ({
    id: row[`period_id_${i}`],
    fechaInicio: row[`inicio_${i}`],
    estado: row[`estado_${i}`],
    razon: row[`razon_${i}`],
  }));

  return (
    <>
      {periods.map((p, index) => {
        const periodLabel = `Período ${index + 1}`;
        const hasData = Boolean(p.id);

        return (
          <React.Fragment key={index}>
            <Divider sx={{ my: 0.5 }} />
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", ml: 1, mt: 1 }}
            >
              {periodLabel}
            </Typography>

            <MenuItem
              disabled={!RRHH ? p.estado === 2 : null} // no editar si ya está aprobado
              onClick={() => onEdit(row, p.id, index + 1)}
            >
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                {hasData ? "Editar" : "Agregar nuevo"}
              </ListItemText>
            </MenuItem>

            <MenuItem
              disabled={!hasData || p.estado === 2 || !RRHH}
              onClick={() => onApprove(row, p.id)}
            >
              <ListItemIcon>
                <CheckIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Aprobar</ListItemText>
            </MenuItem>

            <MenuItem
              disabled={
                !hasData || p.estado === 3 || !RRHH || (!RRHH && hasData)
              }
              onClick={() => onReject(row, p.id)}
            >
              <ListItemIcon>
                <CloseIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Rechazar</ListItemText>
            </MenuItem>

            <MenuItem
              disabled={!hasData || p.estado !== 2}
              onClick={() => onPdf(row, p.id)}
            >
              <ListItemIcon>
                <PictureAsPdfIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Generar constancia</ListItemText>
            </MenuItem>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default PeriodActionMenu;
